export { default as RoleManageConfig } from './RoleManageConfig';
